import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Table } from "@pentabd/ui";

import { TableColumn } from "./CreateProcurementListTableColumn";
import { useNavigate } from "react-router-dom";
import { useProcurementList } from "@hooks/procurements/procurement/useProcurements";
import { ProcurementsResponseType } from "@type/procurements/procurement";
import { Pagination } from "@type/procurements/pagination";
import SearchController from "@components/SearchController";
// import { useUser } from "@hooks/useUser";

import { TablePagination } from "@helpers/tablePagination";

export const CreateProcurementListTable = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { control } = useForm();

  // const { user } = useUser();
  // const { realm_roles: roles } = user || {};
  const { handleQuery, procurementState } = useProcurementList();

  const { getData } = procurementState;

  const { data, pagination } = getData || ({} as ProcurementsResponseType);
  const { total } = pagination || ({} as Pagination);

  return (
    <Table
      header={{
        title: t("PROCUREMENT_CREATE_TABLE.TABLE.HEADER"),
        badge: {
          label: `${total || 0}`,
          size: "sm",
          type: "info",
        },
        buttons: [
          <SearchController
            control={control}
            name="search"
            onChange={(value) => {
              handleQuery("search", value);
            }}
          />,
        ],
      }}
      columns={TableColumn(t, navigate)}
      rows={data}
      // actions={[
      //   {
      //     onClick(id) {
      //       navigate(`${id}`);
      //     },
      //     customIcon: <IconEye size="20" />,
      //   },
      // ]}
      pagination={TablePagination(pagination, handleQuery)}
    />
  );
};
